import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next";
import i18n, { _get_i18Lang } from '../../i18n';
import AboutService from "../../Services/OnePageServices";
import { Box, Typography } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import { HeaderBox } from './mBookListPage';
const MobileAboutUs = () => {
    const { t } = useTranslation();
    const navigate = useNavigate()

    const [about, setAbout] = React.useState({
        __html: "",
    });

    function createMarkup() {
        const words = about?.__html?.split(/\s+/); // Split by whitespace to count words
        const isLong = words?.length > 44;

        return {
            // __html: isLong
            __html: about?.__html

            //   ? words?.slice(0, 44).join(" ") + "..."
            //   : about?.__html || "",
        };
    }

    useEffect(() => {
        AboutService.getAboutData(_get_i18Lang()).then((result: any) => {
            if (result) {
                setAbout({ __html: result.result.aboutGSTContent });
            }
        });
    }, [i18n.language]);
    return (
        <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <HeaderBox>
                <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 16, top: 35, p: 0 }}>
                    <ArrowBackIosIcon sx={{ color: "white", fontSize: '18px' }} />
                </IconButton>
                <IconButton onClick={() => navigate("/")} sx={{ position: 'absolute', left: 48, top: 35, p: 0 }}>
                    <HomeOutlinedIcon sx={{ color: "white", fontSize: '24px' }} />
                </IconButton>
                <Typography variant="caption" sx={{ color: "#ffffffdd", opacity: 0.9, mb: 0.5 }}>
                    {t("shrihari_tr")}
                </Typography>
                <Typography variant="h6" sx={{ color: "#ffffffdd", opacity: 0.9, fontSize: 15 }}>
                    {t("Introduction_tr")}
                </Typography>
            </HeaderBox>
            <Box sx={{ flex: 1, overflowY: 'auto', paddingBottom: '60px', '&::-webkit-scrollbar': { display: 'none' }, msOverflowStyle: 'none', scrollbarWidth: 'none' }}>
                <div
                    className='html-content'
                    style={{ width: "100%", padding: 8, fontSize: "10px" }}
                    dangerouslySetInnerHTML={createMarkup()}
                ></div>
            </Box>
        </Box>
    )
}

export default MobileAboutUs